import { openSSO, openSSObyGet } from '01_core/logics/openSSO';

/**
 * メニューのリンク（アクションコード2）の時の処理。
 */
export const menuLinkActions = {
  systemlink_biz_anpi: (pms, loginUserInfo, systemLink) => () => {
    const { bizAnpiUrl } = systemLink;
    const url = bizAnpiUrl;
    openSSObyGet(url, 'bizAnpi');
  },
};

export const openLinkSystem = (url, data, key) => {
  const param = {
    data: data,
    system: 'safe',
  };
  openSSO(param, url, key);
};
